import { render, staticRenderFns } from "./dashResAndStudents.vue?vue&type=template&id=41536560&scoped=true"
import script from "./dashResAndStudents.vue?vue&type=script&lang=js"
export * from "./dashResAndStudents.vue?vue&type=script&lang=js"
import style0 from "./dashResAndStudents.vue?vue&type=style&index=0&id=41536560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41536560",
  null
  
)

export default component.exports